import React, { useEffect, useRef } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const FormErrorSummary = ({
  errors = [],
  title = 'Please correct the following errors:',
  severity = 'error',
  dismissible = false,
  onDismiss = null,
  sx = {},
}) => {
  const errorSummaryRef = useRef(null);

  useEffect(() => {
    if (errors && errors.length > 0 && errorSummaryRef.current) {
      errorSummaryRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [errors]);

  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Box ref={errorSummaryRef} sx={{ mb: 2, ...sx }}>
      <Alert
        severity={severity}
        onClose={dismissible && onDismiss ? onDismiss : undefined}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {errors.length === 1 ? (
          <Box>{errors[0]}</Box>
        ) : (
          <List dense sx={{ py: 0 }}>
            {errors.map((error, index) => (
              <ListItem key={index} sx={{ py: 0, px: 0 }}>
                <ListItemText
                  primary={error}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Alert>
    </Box>
  );
};

export default FormErrorSummary;
